(function ($) {
    var topics = {
        accounts: {
            yearFilter: 'accounts-year-filter',
            listFilter: 'accounts-list-filter',
            listFilterOptions: 'accounts-list-filter-options'
        },
        alerts: {
            countValue: 'alerts-count-value',
            countRefresh: 'alerts-count-refresh'
        },
        claims : {
            requiredAttentionItems: 'required-attention-items'
        },
        opportunities: {
            countValue: 'opportunities-count-value'
        },
        notifications: {
            countValue: 'notifications-count-value',
            countRefresh: 'notifications-count-refresh'
        },
    };

    $.extend(true, $, { cdh: { topics: topics } });
})(jQuery);